import { render, staticRenderFns } from "./payments-report.vue?vue&type=template&id=60bfda5c&scoped=true"
import script from "./payments-report.vue?vue&type=script&lang=js"
export * from "./payments-report.vue?vue&type=script&lang=js"
import style0 from "./payments-report.vue?vue&type=style&index=0&id=60bfda5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bfda5c",
  null
  
)

export default component.exports